module.exports = __webpack_public_path__ + "static/media/C10.0b5f3bef.png";